import React, { useState, useEffect } from "react";
import { api } from "../lib/api";
import { useData, save } from "../hooks/useData";
import { toast } from "sonner";
import { Card, Button, Field, Input } from "./shared";
import { CompanyLogo } from "./CompanyLogo";

const FIELDS = [["gstin", "GST Number"], ["pan", "PAN Number"], ["phone1", "Phone Number 1"],
["phone2", "Phone Number 2"], ["email", "Email ID"], ["website", "Website"]];

export const CompanyDetails = () => {
  const { data: company, reload } = useData("/company");
  const [form, setForm] = useState({});
  const [logoKey, setLogoKey] = useState(0);
  const [uploading, setUploading] = useState(false);
  useEffect(() => { if (company) setForm(company); }, [company]);

  const submit = async (e) => {
    e.preventDefault();
    if (!String(form.name || "").trim()) { toast.error("Company name is required"); return; }
    try {
      await save("put", "/company", form);
      toast.success("Company details saved — new challans will use these");
      reload();
    } catch (err) { toast.error(err.response?.data?.detail || "Save failed"); }
  };

  const onLogo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      await api.post("/company/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Logo uploaded");
      setForm((f) => ({ ...f, has_logo: true }));
      setLogoKey((k) => k + 1);
      reload();
    } catch (err) { toast.error(err.response?.data?.detail || "Upload failed"); }
    finally { setUploading(false); }
  };

  return (
    <Card className="p-5 mb-6">
      <p className="text-sm font-semibold text-slate-800 mb-1 font-head">Company Details</p>
      <p className="text-xs text-slate-400 mb-4">These appear automatically on the header of every newly generated challan.</p>
      <form onSubmit={submit} className="grid md:grid-cols-2 gap-3">
        <Field label="Company Name" required className="md:col-span-2"><Input value={form.name || ""} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="company-name" /></Field>
        <Field label="Address" className="md:col-span-2"><Input value={form.address || ""} onChange={(e) => setForm({ ...form, address: e.target.value })} data-testid="company-address" /></Field>
        {FIELDS.map(([k, l]) => (
          <Field key={k} label={l}><Input value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`company-${k}`} /></Field>
        ))}
        <div className="md:col-span-2 flex items-center gap-4 border-t border-slate-100 pt-4 mt-1">
          <CompanyLogo hasLogo={form.has_logo} refreshKey={logoKey} className="h-16 w-16 rounded-lg border border-slate-200 bg-slate-50 p-1"
            fallback={<div className="h-16 w-16 rounded-lg border border-dashed border-slate-300 grid place-items-center text-[10px] text-slate-400">No logo</div>} />
          <div>
            <input type="file" accept="image/*" onChange={onLogo} className="text-sm" data-testid="company-logo-input" />
            <p className="text-xs text-slate-400 mt-1">{uploading ? "Uploading…" : "PNG/JPG, up to 3MB. Shown on challans."}</p>
          </div>
        </div>
        <div className="md:col-span-2 flex justify-end"><Button type="submit" data-testid="company-save">Save Company Details</Button></div>
      </form>
    </Card>
  );
};
